import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class UserService {
    baseUrl: string = 'User.svc';
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    authenticate(dataToBePost) {  
        return this._ajaxService.POST(this.baseUrl + "/authenticate", dataToBePost);
    }
    access() {      
        return this._ajaxService.GET(this.baseUrl + "/access");        
    }
    profile() {        
        return this._ajaxService.GET(this.baseUrl + "/profile");        
    }
    changePassword(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/changePassword",dataToBePost);        
    }
    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
    delete(id) {        
        return this._ajaxService.GET(this.baseUrl + "/delete/" + id);        
    }
    select(id) {        
        return this._ajaxService.GET(this.baseUrl + "/select/"+id);        
    }
    all(pageIndex,pageSize,sortHeaderName,sortDirection,filterText) {
       return this._ajaxService.GET(this.baseUrl + "/all/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterText);       
    }
    selectGender(id) {        
        return this._ajaxService.GET(this.baseUrl + "/gender/"+ (typeof id == "undefined" ? 0 : id));        
    }
    selectLanguages(id) {        
        return this._ajaxService.GET(this.baseUrl + "/systemattr/language/"+ (typeof id == "undefined" ? 0 : id));        
    }
    selectUserMappings(id, type) {        
        return this._ajaxService.GET(this.baseUrl + "/umlist/"+ type + "/" + id);        
    }
    saveUserMappings(umList: any) {        
        return this._ajaxService.POST(this.baseUrl + "/umsave", umList);        
    }
    selectRol(id) {        
        return this._ajaxService.GET(this.baseUrl + "/Rol/"+ (typeof id == "undefined" ? 0 : id));        
    }
    selectPage(id) {        
        return this._ajaxService.GET(this.baseUrl + "/pageDetail/"+ (typeof id == "undefined" ? 0 : id));        
    }
    saveRol(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/saveRol", dataToBePost);        
    }
    saveParams(recordsPerPage) {        
        return this._ajaxService.POST(this.baseUrl + "/saveParams/" + recordsPerPage, []);        
    }
    selectParams() {        
        return this._ajaxService.GET(this.baseUrl + "/selectParams");        
    }

}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/user.service.ts